// export const baseUrl = "http://192.168.1.41:8000";
// export const socketUrl = "http://192.168.1.41:5004";

// export const baseUrl = "https://api.Green Crypto X.com";
// export const socketUrl = "https://streams.Green Crypto X.com";
//

export const baseUrl = process.env.REACT_APP_baseUrl;
export const socketUrl = process.env.REACT_APP_SOCKET_IO_URL;
